import Paper, { PaperProps } from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '@rentguru/commons-utils';

const useStyles = makeStyles({
  paper: {
    borderRadius: 12,
    textAlign: 'center',
    marginBottom: 30,
    overflowX: 'hidden',
    boxShadow: 'none',
    outline: `1px solid ${Colors.PORCELAIN_GREY_3}`,
  },
});

type ElevatedPaperTableProps = PaperProps;

export const ElevatedPaperTable = ({ children, style, ...rest }: ElevatedPaperTableProps) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} style={style || {}} elevation={10} {...rest}>
      {children}
    </Paper>
  );
};
